import type { IconDefinition } from '../index.tsx';

export const iconChevronUp: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconChevronUp',
  icon: [
    16,
    16,
    [],
    '',
    'M7.99985 7.82873L12.5856 12.4145L15.4141 9.58609L7.99985 2.17187L0.585636 9.58609L3.41406 12.4145L7.99985 7.82873Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
